<template>
  <v-form ref="form" lazy-validation>
    <div v-for="(question) of surveyTemplates" :key="question.id">
      <v-divider></v-divider>
      <h4 class="fs-16 fw-semi-bold text-xs-left py-3 px-4 q-title">{{question.questionTitle}}
        <span class="red--text" v-if="question.mandatory">(必須)</span></h4>
      <v-divider></v-divider>
      <template v-if="question.surveyTemplateType === 'RADIO'">
        <v-radio-group v-model="question.buttons" column class="pa-4" :disabled="disabled">
          <template v-for="option in question.questionForm">
            <v-radio :label="option.value" :value="option.key" v-bind:key="option.key" class="mb-4">
              <template slot="label">
                <span>{{option.value}}</span>
              </template>
            </v-radio>
          </template>
        </v-radio-group>
      </template>
      <v-list class="pa-4" v-if="question.surveyTemplateType === 'CHECKBOX'">
        <template v-for="option in question.questionForm">
          <v-layout v-bind:key="option.key">
            <v-checkbox v-model="option.selected" class="mb-4" @change="checkChanged(question)"
                        :disabled="disabled">
              <template slot="label">
                <span>{{option.value}}</span>
              </template>
            </v-checkbox>
          </v-layout>
        </template>
      </v-list>
      <template v-if="question.surveyTemplateType === 'TEXT'">
        <v-textarea
          outline
          full-width
          clearable
          hide-details
          no-resize
          height="150"
          v-model="question.answer"
          class="mt-3 mx-4"
          placeholder="質問に対する回答を1000字以内で入力してください。"
          @change="byteCheck($event,question.id)"
          :disabled="disabled"
        >
        </v-textarea>
        <div class="text-xs-right mr-4" :class="{'pink--text' : getByteLength(question.answer) / 1000 > 0.99}">
          {{ getByteLength(question.answer) }} / 1000字
        </div>
      </template>
    </div>
    <simple-alert :show="SimpleAlert" :title="'アンケート'"
                  :content="this.result"
                  :confirm-button-text="'確認'"
                  :confirm-action="closeSimpleAlert">
    </simple-alert>
  </v-form>
</template>

<script>
import helper from 'util/helpers'
import SimpleAlert from '@/components/dialog/simple_alert'

export default {
  name: 'survey_template',
  components: {SimpleAlert},
  props: {
    surveyTemplates: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      result: '',
      SimpleAlert: false
    }
  },
  computed: {
    checkboxWatch: function () {
      return this.surveyTemplates.filter(t => t.surveyTemplateType === 'CHECKBOX')
    }
  },
  watch: {
    checkboxWatch: {
      handler: function (after, before) {
        // Return the object that changed
        let changed = after.filter(function (p) {
          return Object.keys(p).some(function (prop) {
            return prop === 'changed' && p[prop] === true
          })
        })
        changed.forEach(function (c) {
          c.changed = false
          c.buttons = c.questionForm.reduce((unique, item) => {
            return !item.selected ? unique : [...unique, item.key]
          }, [])
        })
      },
      deep: true
    }
  },
  methods: {
    checkChanged (s) {
      s.changed = true
    },
    getByteLength (s) {
      return helper.getByteLength(s)
    },
    byteCheck (inputMessage, templateId) {
      let filteredMsg = helper.textXssFilter(inputMessage)
      var targetTemplate = this.surveyTemplates.filter(x => {
        return x.id === templateId
      })[0]
      var index = this.surveyTemplates.indexOf(targetTemplate)
      if (inputMessage !== filteredMsg) {
        this.surveyTemplates[index].answer = filteredMsg
        this.showSimpleAlert('タグは許可されません。')
      }
      let inputLength = this.getByteLength(targetTemplate.answer)
      let maxLength = 1000
      if (inputLength > maxLength) {
        this.surveyTemplates[index].answer = helper.cutByLen(this.surveyTemplates[index].answer, maxLength - 1)
        this.showSimpleAlert('最大入力文字数(' + maxLength + 'byte)を超えました。')
      }
    },
    showSimpleAlert (msg) {
      this.result = msg
      this.SimpleAlert = true
    },
    closeSimpleAlert () {
      this.SimpleAlert = false
      this.result = ''
    }
  }
}
</script>

<style scoped>
  .q-title {
    background-color: #f9fafb;
    line-height: 26px;
  }
</style>



// WEBPACK FOOTER //
// src/components/menus/survey/survey_template.vue